import React from 'react';
import { FormattedNumber } from 'react-intl';

import CalculateCommissionAffiliate from 'components/CalculateCommissionAffiliate';
import PermissionHide from 'v2/components/Shared/PermissionHide';

interface IProps {
  product: any;
  commission?: 'percentage' | 'subscription' | 'normal' | 'coproduction';
}

enum ChargeType {
  SIGNATURE = 'A',
  NORMAL = 'N',
  OPENED = 'L',
  FREE = 'G'
}

const ShowPrice = ({ product, commission }: IProps) => {
  if (product.has_children) {
    return (
      <span className='text-text-secondary/60 m-0 text-sm'>
        <b>Consultar variações</b>
      </span>
    );
  }

  if (commission === 'percentage') {
    return (
      <span className='text-sm font-bold text-green-600'>
        <PermissionHide inverse action='myeduzz:meus-produtos:ocultar-valores'>
          {product.coproduction_commission_type == 'P' ? (
            (product.coproduction_commission_percent || 0) + '%'
          ) : (
            <FormattedNumber value={product.coproduction_commission_value || 0} format='BRL' />
          )}
        </PermissionHide>
        <PermissionHide inverse={false} action='myeduzz:meus-produtos:ocultar-valores'>
          <em className='text-text-secondary/60 font-normal not-italic'>oculto</em>
        </PermissionHide>
      </span>
    );
  }

  if (commission === 'subscription') {
    return (
      <span className='text-sm font-bold text-green-600'>
        <PermissionHide inverse action='myeduzz:meus-produtos:ocultar-valores'>
          <FormattedNumber value={product.comission_subscription || 0} format='BRL' />
        </PermissionHide>
        <PermissionHide inverse={false} action='myeduzz:meus-produtos:ocultar-valores'>
          <em className='text-text-secondary/60 font-normal not-italic'>oculto</em>
        </PermissionHide>
      </span>
    );
  }

  return (
    <div>
      <div className='text-sm font-bold text-green-600'>
        {product.charge_type === ChargeType.SIGNATURE && (
          <PermissionHide inverse action='myeduzz:meus-produtos:ocultar-valores'>
            <FormattedNumber value={product.recurring_value || 0} format='BRL' />
            <span className='ml-1 font-normal text-green-600'>recorrente</span>
          </PermissionHide>
        )}

        {product.charge_type === ChargeType.NORMAL && (
          <span className='text-green-600'>
            <PermissionHide inverse action='myeduzz:meus-produtos:ocultar-valores'>
              <FormattedNumber value={product.price} format='BRL' />
            </PermissionHide>
          </span>
        )}

        {(!product.charge_type || product.charge_type === ' ') && (
          <PermissionHide inverse action='myeduzz:meus-produtos:ocultar-valores'>
            <FormattedNumber value={0} format='BRL' />
          </PermissionHide>
        )}

        {product.charge_type === ChargeType.OPENED && (
          <PermissionHide inverse action='myeduzz:meus-produtos:ocultar-valores'>
            Valor Aberto
          </PermissionHide>
        )}

        {product.charge_type === ChargeType.FREE && <span>Grátis</span>}

        {product.charge_type !== ChargeType.FREE && (
          <PermissionHide inverse={false} action='myeduzz:meus-produtos:ocultar-valores'>
            <em className='text-text-secondary/60 font-normal not-italic'>oculto</em>
          </PermissionHide>
        )}
      </div>

      {commission === 'normal' && (
        <div className='text-text-secondary/60 text-xs'>
          {product.charge_type === ChargeType.SIGNATURE && (
            <span>
              <PermissionHide inverse action='myeduzz:meus-produtos:ocultar-valores'>
                <CalculateCommissionAffiliate
                  price={product.recurring_value || 0}
                  commissionType={product.recurring_comission_type}
                  commissionValue={product.recurring_comission_value}
                />
              </PermissionHide>
              <PermissionHide inverse={false} action='myeduzz:meus-produtos:ocultar-valores'>
                <em className='not-italic'>oculto</em>
              </PermissionHide>{' '}
              de Comissão recorrente
            </span>
          )}

          {product.charge_type === ChargeType.NORMAL && (
            <span>
              <PermissionHide inverse action='myeduzz:meus-produtos:ocultar-valores'>
                <CalculateCommissionAffiliate
                  price={product.price || 0}
                  commissionType={product.comission_type}
                  commissionValue={product.comission_value}
                />
              </PermissionHide>
              <PermissionHide inverse={false} action='myeduzz:meus-produtos:ocultar-valores'>
                <em className='not-italic'>oculto</em>
              </PermissionHide>{' '}
              de Comissão
            </span>
          )}

          {(!product.charge_type || product.charge_type === ' ') && (
            <span>
              <PermissionHide inverse action='myeduzz:meus-produtos:ocultar-valores'>
                <CalculateCommissionAffiliate price={0} commissionType={'V'} commissionValue={0} />
              </PermissionHide>
              <PermissionHide inverse={false} action='myeduzz:meus-produtos:ocultar-valores'>
                <em className='not-italic'>oculto</em>
              </PermissionHide>{' '}
              de Comissão
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default ShowPrice;
